import { enhancedRequest } from "../utils/request.js";

/** 登录认证（无需携带 X-Authorization-Token） */
const authLogin = (data) =>
  enhancedRequest({
    url: "/api/v1/user/auth/login",
    method: "post",
    data,
    skipAuth: true,
    acceptBizCodes: [0],
  });

export { authLogin };
